import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuthStore } from '../stores/auth.store';

/**
 * Handles OAuth callback redirects (e.g., Google Sign-In).
 * Extracts tokens from URL params, stores them, and redirects to dashboard.
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { setTokens, getCurrentUser } = useAuthStore();

  useEffect(() => {
    const accessToken = searchParams.get('accessToken');
    const refreshToken = searchParams.get('refreshToken');
    const isNewUser = searchParams.get('isNewUser') === '1';

    if (accessToken && refreshToken) {
      // Store tokens and mark as authenticated
      setTokens(accessToken, refreshToken);
      // Fetch user profile
      getCurrentUser().then(() => {
        navigate(isNewUser ? '/dashboard' : '/dashboard', { replace: true });
      }).catch(() => {
        navigate('/dashboard', { replace: true });
      });
    } else {
      // No tokens — redirect to login with error
      navigate('/login?error=oauth_failed', { replace: true });
    }
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-slate-600">Signing you in...</p>
      </div>
    </div>
  );
}
